module.exports = {"TXTWCL_Sorry___an_error_has_occurred":{"id":"TXTWCL_Sorry___an_error_has_occurred","defaultMessage":"Žao nam je, pojavila se pogreška"}}